import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-services',
  template: `
      <!-----------3----------->
      <div class="container">
          <div class="home" data-css-scope="home">
              <section class="services" style="color: darkblue">
                  <p class="heading2"> خدمات هشتگ بیمه را بیشتر بشناسیم</p>
                  <div class="section-info services-content">
                      <div class="col">
                          <div class="col-content">
                              <img class="service-1" alt=" آنلاین مشاوره بگیر"
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAADmAQMAAADshvsxAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB5JREFUeNrtwTEBAAAAwqD1T20ND6AAAAAAAACAfwMb2gAB1svizwAAAABJRU5ErkJggg==">
                              <p class="services-title"> آنلاین مشاوره بگیر</p>
                              <p>
                                  جهت انتخاب آگاهانه خدمات بیمه شما را یاری می دهیم</p>
                          </div>
                      </div>
                      <div class="col">
                          <div class="col-content">
                              <img class="service-2" alt="آنلاین خرید کن"
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADmAQMAAAD/UbvFAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB5JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAADg2wAa9AABvlxmXQAAAABJRU5ErkJggg==">
                              <p class="services-title"> آنلاین خرید کن</p>
                              <p>
                                  تمام مراحل درخواست را بصورت کاملا آنلاین ثبت کنید</p>
                          </div>
                      </div>
                      <div class="col">
                          <div class="col-content">
                              <img class="service-3" alt="آنلاین پرداخت کن"
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAADoAQMAAADWjJpBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB1JREFUeNrtwQENAAAAwqD3T20PBxQAAAAAAADwbhwYAAHo9q0+AAAAAElFTkSuQmCC">
                              <p class="services-title"> آنلاین پرداخت کن</p>
                              <p>
                                  از درگاه امن بانکی حق بیمه را پرداخت کنید</p>
                          </div>
                      </div>
                      <div class="col">
                          <div class="col-content">
                              <img class="service-4" alt="آنلاین بیمه نامه دریافت کن"
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPQAAADoAQMAAADi9VtdAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB5JREFUeNrtwQENAAAAwqD3T20PBxQAAAAAAADAhwEdAAABSxFJRQAAAABJRU5ErkJggg==">
                              <p class="services-title">آنلاین بیمه نامه دریافت کن</p>
                              <p>
                                  بیمه نامه خود را در سریعترین زمان آنلاین دریافت و دانلود کنید</p>
                          </div>
                      </div>
                  </div>
              </section>
              <br>
              <br>
              <br>
          </div>
      </div>
      <!-----------4----------->
      <section style="background: #f1f1f1; padding: 30px;text-align: center;">
          <style>
              img {
                  margin: 10px;
              }
          </style>
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <h2 class="heading2">شرکت های بیمه <span> </span></h2>
                      <br>
                      <br>
                      <div class="row justify-content-center">
                          <div class="col-12 col-xl-10 col-lg-10 col-md-10 col-xs-6">
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p12.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p1.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p10.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p16.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p11.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p3.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p7.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p8.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p9.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p4.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p5.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p20.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p14.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p15.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p13.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p17.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p18.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p19.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p2.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p21.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p22.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p23.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p24.jpg" height="70" width="140" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p25.jpg" height="70" width="140" alt="">
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <!-----------5----------->
      <div class="page-wrapper p-t-180 p-b-100 home-margin">
          <div class="wrapper wrapper--w960">
              <section id="overview" class="section overview">
                  <div class="row">
                      <div class="col-md-8 col-md-offset-2 text-center">
                          <h2 class="heading2">هشتگ بیمه همیار مردم و نمایندگان بیمه <span> </span></h2>
                          <br>
                          <!--                              <p class="section-intro">بیمه یعنی سرمایه گذاری برای آرامش </p>-->
                      </div>
                      <br>
                      <div class="col-md-12 text-center overview-video">
                          <style>
                              .h_iframe-aparat_embed_frame {
                                  position: relative;
                              }

                              .h_iframe-aparat_embed_frame .ratio {
                                  display: block;
                                  width: 100%;
                                  height: auto;
                              }

                              .h_iframe-aparat_embed_frame iframe {
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                              }
                          </style>
                          <div class="h_iframe-aparat_embed_frame"><span
                                  style="display: block;padding-top: 57%"></span>
                              <iframe src="https://www.aparat.com/video/video/embed/videohash/19iA7/vt/frame"
                                      allowFullScreen="true" webkitallowfullscreen="true"
                                      mozallowfullscreen="true"></iframe>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
      </div>
      <!--      <section style="background: #f1f1f1; padding: 30px;text-align: center;">-->
      <!--          <div class="container">-->
      <!--              <div class="row">-->
      <!--                  <div class="col-12">-->
      <!--                      <h2 class="heading2">شرکت های بیمه <span> </span></h2>-->
      <!--                      <br>-->
      <!--                      <br>-->
      <!--                      <div class="row justify-content-center">-->
      <!--                          <div class="col-12 col-xl-10 col-lg-10 col-md-10 col-sm-12">-->
      <!--                              <div class="col-md-2 col-xs-6">-->
      <!--                                  <img src="../assets/images/saman.insurance.svg" height="70" width="140" alt="">-->
      <!--                              </div>-->
      <!--                              <div class="col-md-2 col-xs-6">-->
      <!--                                  <img src="../assets/images/724.svg" height="70" width="140" alt="">-->
      <!--                              </div>-->
      <!--                              <div class="col-md-2">-->
      <!--                                  <img src="../assets/images/bale.svg" height="70" width="140" alt="">-->
      <!--                              </div>-->
      <!--                              <div class="col-2">-->
      <!--                                  <img src="../assets/images/bimebazar.svg" height="70" width="140" alt="">-->
      <!--                              </div>-->
      <!--                              <div class="col-280">-->
      <!--                                  <img src="../assets/images/apan.svg" height="70" width="140" alt="">-->
      <!--                              </div>-->
      <!--                                                       </div>-->
      <!--                      </div>-->
      <!--                  </div>-->
      <!--              </div>-->
      <!--          </div>-->
      <!--      </section>-->

      <!--      <section style="color: darkblue; margin-top: 70px;">-->
      <!--                 <style>-->
      <!--                     body {-->
      <!--              align-items: center;-->
      <!--              background: #E3E3E3;-->
      <!--              display: flex;-->
      <!--              height: 100vh;-->
      <!--              justify-content: center;-->
      <!--          }-->

      <!--          @-webkit-keyframes scroll {-->
      <!--              0% {-->
      <!--                  -webkit-transform: translateX(0);-->
      <!--                  transform: translateX(0);-->
      <!--              }-->
      <!--              100% {-->
      <!--                  -webkit-transform: translateX(calc(-250px * 7));-->
      <!--                  transform: translateX(calc(-250px * 7));-->
      <!--              }-->
      <!--          }-->

      <!--          @keyframes scroll {-->
      <!--              0% {-->
      <!--                  -webkit-transform: translateX(0);-->
      <!--                  transform: translateX(0);-->
      <!--              }-->
      <!--              100% {-->
      <!--                  -webkit-transform: translateX(calc(-250px * 7));-->
      <!--                  transform: translateX(calc(-250px * 7));-->
      <!--              }-->
      <!--          }-->

      <!--          .slider {-->
      <!--              background: pr;-->
      <!--              box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.125);-->
      <!--              height: 100px;-->
      <!--              margin: auto;-->
      <!--              overflow: hidden;-->
      <!--              position: relative;-->
      <!--              width: 960px;-->
      <!--          }-->

      <!--          .slider::before, .slider::after {-->
      <!--              background: linear-gradient(to right, white 0%, rgba(255, 255, 255, 0) 100%);-->
      <!--              content: "";-->
      <!--              height: 100px;-->
      <!--              position: absolute;-->
      <!--              width: 200px;-->
      <!--              z-index: 2;-->
      <!--          }-->

      <!--          .slider::after {-->
      <!--              right: 0;-->
      <!--              top: 0;-->
      <!--              -webkit-transform: rotateZ(180deg);-->
      <!--              transform: rotateZ(180deg);-->
      <!--          }-->

      <!--          .slider::before {-->
      <!--              left: 0;-->
      <!--              top: 0;-->
      <!--          }-->

      <!--          .slider .slide-track {-->
      <!--              -webkit-animation: scroll 40s linear infinite;-->
      <!--              animation: scroll 40s linear infinite;-->
      <!--              display: flex;-->
      <!--              width: calc(250px * 14);-->
      <!--          }-->

      <!--          .slider .slide {-->
      <!--              height: 100px;-->
      <!--              width: 250px;-->
      <!--          }</style>-->


      <!--          <p class="heading2">همکاران تجاری ما </p>-->
      <!--          <br>-->
      <!--          &lt;!&ndash; partial:index.partial.html &ndash;&gt;-->
      <!--          <div class="slider">-->
      <!--              <div class="slide-track">-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="slide">-->
      <!--                      <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="">-->
      <!--                  </div>-->
      <!--              </div>-->
      <!--          </div>-->
      <!--          <br>-->
      <!--      </section>-->
      <!-----------6----------->
      <section style="background: #f1f1f1; padding: 30px;text-align: center;">
          <style>
              img {
                  margin: 10px;
              }
          </style>
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <h2 class="heading2">همکاران تجاری ما<span> </span></h2>
                      <br>
                      <br>
                      <div class="row justify-content-center">
                          <div class="col-md-2 col-sm-2">
                              <img src="assets/images/p-8.png" height="120" width="120" alt="">
                          </div>
                          <div class="col-md-2 col-sm-2">
                              <img src="assets/images/p-7.png" height="120" width="120" alt="">
                              </div>
                              <div class="col-md-2 col-sm-2">
                                  <img src="assets/images/p-2.png" height="120" width="120" alt="">
                              </div>
                          <div class="col-md-2 col-sm-2">
                              <img src="assets/images/p-1.png" height="120" width="120" alt="">
                              </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
  `,
  styleUrls: [
    '../assets/css/navbar.css'
  ]
})
export class AppServicesComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
